import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./store/auth";
import { useSearch } from "./store/search";
import { useNetwork } from "./hooks/useNetwork";

type IconProps = { className?: string };

const IconCart = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);
const IconBox = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
    />
  </svg>
);
const IconUsers = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);
const IconClipboard = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
    />
  </svg>
);
const IconCash = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
    />
  </svg>
);
const IconChart = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    />
  </svg>
);
const IconInventory = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 6h16M4 10h16M4 14h16M4 18h16"
    />
  </svg>
);
const IconTag = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 7h.01M7 3h5a1.99 1.99 0 011.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.99 1.99 0 013 12V7a4 4 0 014-4z"
    />
  </svg>
);
const IconCog = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);
const IconSearch = ({ className }: IconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

interface NavItem {
  to: string;
  label: string;
  short: string;
  icon: (p: IconProps) => JSX.Element;
  // Color del icono cuando esta activo (slate-900 sidebar oscuro, cada seccion tiene su propio acento)
  color: string;
  end?: boolean;
}

const NAV: NavItem[] = [
  { to: "/", label: "Venta", short: "Venta", icon: IconCart, color: "emerald", end: true },
  { to: "/productos", label: "Productos", short: "Prod", icon: IconBox, color: "sky" },
  { to: "/clientes", label: "Clientes", short: "Cli", icon: IconUsers, color: "violet" },
  { to: "/cta-cte", label: "Cuenta corriente", short: "CtaCte", icon: IconClipboard, color: "amber" },
  { to: "/caja", label: "Caja", short: "Caja", icon: IconCash, color: "teal" },
  { to: "/reportes", label: "Reportes", short: "Rep", icon: IconChart, color: "pink" },
  { to: "/inventario", label: "Inventario", short: "Inv", icon: IconInventory, color: "indigo" },
  { to: "/precios", label: "Precios", short: "Prec", icon: IconTag, color: "rose" },
];

// Tailwind necesita las clases completas en el source para incluirlas en el build.
// Mapeo explicito de color -> clases (activo + hover).
const COLOR_CLASSES: Record<string, { active: string; idle: string }> = {
  emerald: { active: "bg-emerald-500/20 text-emerald-400 border-l-emerald-400", idle: "text-emerald-400/40" },
  sky: { active: "bg-sky-500/20 text-sky-400 border-l-sky-400", idle: "text-sky-400/40" },
  violet: { active: "bg-violet-500/20 text-violet-400 border-l-violet-400", idle: "text-violet-400/40" },
  amber: { active: "bg-amber-500/20 text-amber-400 border-l-amber-400", idle: "text-amber-400/40" },
  teal: { active: "bg-teal-500/20 text-teal-400 border-l-teal-400", idle: "text-teal-400/40" },
  pink: { active: "bg-pink-500/20 text-pink-400 border-l-pink-400", idle: "text-pink-400/40" },
  indigo: { active: "bg-indigo-500/20 text-indigo-400 border-l-indigo-400", idle: "text-indigo-400/40" },
  rose: { active: "bg-rose-500/20 text-rose-400 border-l-rose-400", idle: "text-rose-400/40" },
  slate: { active: "bg-slate-700 text-slate-200 border-l-slate-400", idle: "text-slate-400/40" },
};

function formatTime(d: Date) {
  return d.toLocaleTimeString("es-AR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export default function App() {
  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);
  const online = useNetwork();
  const navigate = useNavigate();
  const [now, setNow] = useState<Date>(new Date());
  const search = useSearch((s) => s.query);
  const setSearch = useSearch((s) => s.setQuery);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "F1") {
        e.preventDefault();
        const el = document.getElementById(
          "global-search"
        ) as HTMLInputElement | null;
        el?.focus();
        el?.select();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const navItemClass =
    (color: string) =>
    ({ isActive }: { isActive: boolean }) => {
      const c = COLOR_CLASSES[color] ?? COLOR_CLASSES.emerald;
      return `tip w-12 h-12 rounded-xl flex items-center justify-center transition-colors border-l-2 ${
        isActive
          ? `${c.active} font-semibold`
          : `text-slate-300 hover:bg-slate-800 border-l-transparent`
      }`;
    };

  return (
    <div className="flex h-screen overflow-hidden bg-slate-100">
      <aside className="w-16 bg-slate-900 text-slate-300 flex flex-col items-center py-4 gap-1.5">
        <div className="w-11 h-11 mb-3 flex items-center justify-center select-none drop-shadow-md">
          <img
            src="/logo.png"
            alt="Maxi Kiosko JL"
            className="w-full h-full object-contain"
          />
        </div>
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-tip={item.label}
            className={navItemClass(item.color)}
          >
            <item.icon className="w-5 h-5" />
          </NavLink>
        ))}
        <div className="flex-1" />
        <NavLink
          to="/configuracion"
          data-tip="Configuración"
          className={navItemClass("slate")}
        >
          <IconCog className="w-5 h-5" />
        </NavLink>
        <button
          onClick={handleLogout}
          data-tip="Cerrar sesión"
          className="tip w-12 h-10 rounded-xl flex items-center justify-center text-slate-400 hover:text-rose-400 hover:bg-slate-800"
          title="Cerrar sesión"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
        </button>
      </aside>

      <main className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b border-slate-200 px-6 py-3 flex items-center gap-4">
          <div className="relative flex-1 max-w-2xl">
            <IconSearch className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              id="global-search"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscar producto, código o escanear..."
              className="w-full pl-10 pr-20 py-3 bg-slate-50 border border-slate-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:bg-white"
            />
            <kbd className="absolute right-3 top-1/2 -translate-y-1/2 px-2 py-1 bg-white border border-slate-300 rounded text-xs text-slate-500 font-mono">
              F1
            </kbd>
          </div>
          <div className="flex items-center gap-3">
            {/* Caja: status critico, mas prominente */}
            <div className="flex items-center gap-2.5 px-4 py-2 bg-emerald-50 text-emerald-700 rounded-xl border border-emerald-200/60">
              <div className="w-2.5 h-2.5 bg-emerald-500 rounded-full animate-pulse" />
              <span className="font-semibold text-sm">Caja #3 abierta</span>
            </div>
            {/* Status secundario agrupado: online + usuario + reloj */}
            <div className="flex items-center gap-2 text-xs text-slate-500">
              <div
                className={`flex items-center gap-1 ${
                  online ? "text-emerald-600" : "text-amber-600"
                }`}
              >
                <div
                  className={`w-1.5 h-1.5 rounded-full ${
                    online ? "bg-emerald-500" : "bg-amber-500"
                  }`}
                />
                <span>{online ? "online" : "offline"}</span>
              </div>
              <span className="text-slate-300">•</span>
              <span>{user?.nombre ?? "—"}</span>
              <span className="text-slate-300">•</span>
              <span className="font-mono">{formatTime(now)}</span>
            </div>
          </div>
        </header>

        <div className="flex-1 overflow-hidden">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
